import React from 'react';
import { Container } from 'react-bootstrap';
import { ArrowUpRight } from 'react-bootstrap-icons';
import { HashLink } from 'react-router-hash-link';
import { skillGroups } from '../../data/skills';
import './InteriorPages.css';
import './Skills.css';

export const Skills = () => (
  <section className="page-section skills-page">
    <Container>
      <header className="page-heading skills-heading">
        <h1>Skills & tools</h1>
        <p>My toolkit, plus a few examples from my co-ops, projects, and privacy research.</p>
        <nav className="skill-jump-links" aria-label="Skill areas">
          {skillGroups.map(group => (
            <HashLink key={group.id} to={`#${group.id}-skills`}>
              {group.title}<span aria-hidden="true">↓</span>
            </HashLink>
          ))}
        </nav>
      </header>
      <div className="skill-index">
        {skillGroups.map(group => (
          <section className={`skill-area skill-area-${group.id}`} id={`${group.id}-skills`} key={group.id} aria-labelledby={`${group.id}-skills-heading`}>
            <header className="skill-area-heading">
              <h2 id={`${group.id}-skills-heading`}>{group.title}</h2>
              <p>{group.description}</p>
            </header>
            <div className="skill-toolkit">
              <ul className="skill-featured-tools" aria-label={`${group.title} tools`}>
                {group.featured.map(tool => (
                  <li key={tool.name}>
                    <span className={`skill-tool-mark${tool.lightPlate ? ' skill-tool-mark-light' : ''}`}>
                      <img className={tool.monochrome ? 'skill-tool-monochrome' : undefined} src={tool.icon} alt="" width="40" height="40" />
                    </span>
                    <span>{tool.name}</span>
                  </li>
                ))}
              </ul>
              <ul className="skill-supporting-tools" aria-label={`More ${group.title.toLowerCase()} tools`}>
                {group.supporting.map(tool => <li key={tool}>{tool}</li>)}
              </ul>
            </div>
            <div className="skill-in-practice">
              <p className="skill-proof-label">From my work</p>
              <p className="skill-proof">{group.proof}</p>
              <HashLink className="text-link" to={group.link}>{group.example} <ArrowUpRight aria-hidden="true" /></HashLink>
            </div>
          </section>
        ))}
      </div>
    </Container>
  </section>
);
